var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-banner',{staticClass:"mb-4 warning-banner",attrs:{"app":"","icon":_vm.icons.mdiAlertCircleOutline,"icon-color":"red","outlined":""}},[_c('mrx-translation',{attrs:{"token":_vm.token}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }